<template>
    <div id="mobile-navigation-bar" v-bind:class="{'active' : loaded}">
        <div class="row">
            <!--<div class="col-12">-->
            <div class="col-4 btn-wrapper" v-bind:class="{'active' : buttonStates.home}">
                <button class="btn btn-default" v-on:click="navigateHome">
                    <i class="icon-home"></i>
                    <p><translate item="NavigationHome" /></p>
                </button>
            </div>
            <div class="col-4 btn-wrapper" v-bind:class="{'active' : buttonStates.eten}">
                <button class="btn btn-default" v-on:click="navigateCategories">
                    <i class="icon-food"></i>
                    <p><translate item="NavigationFoodAndBeverages" /></p>
                </button>
            </div>
            <div class="col-4 btn-wrapper" v-bind:class="{'active' : buttonStates.checkout}">
                <button class="btn btn-default" v-on:click="navigateCart">
                    <i class="icon-order">
                        <basket-count :totalItems="shoppingCart.model.totalItems"></basket-count>
                    </i>
                    <p><translate item="NavigationOrder" /></p>
                </button>
            </div>
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import shoppingCartService from '../Services/ShopingCartService'
    import basketCount from './basket-count.vue'
    import translate from './translate';
    import translateService from '../Services/TranslateService'; // translateService.TranslationsDictionary['Vue.']

    export default {
        components: { basketCount, translate, translateService },

        data: function () {
            return {
                // return the shoppingcart model defined in services.js
                shoppingCart: shoppingCartService.shoppingCart,
                loaded: false,
                buttonStates: {
                    home: false,
                    eten: false,
                    bestelling: false,
                },
            }
        },

        mounted: function () {
            var that = this;
            $(document).on('vue-items-loaded', function (e) {
                that.getActiveButton();
                that.loaded = true;
            });
            that.getActiveButton();
        },

        methods: {
            navigateHome: function () {
                window.location.href = (document.querySelector("a.header-logo-wrapper") ? document.querySelector("a.header-logo-wrapper").href : "/");
            },

            navigateCategories: function () {
                const mobileCategories = document.getElementById('mobile-categories-container');
                if (mobileCategories) {
                    navState.setNavState('mobileSubHeaderLeft');
                }
                else {
                    window.location.href = (document.querySelector("a.header-logo-wrapper") ? document.querySelector("a.header-logo-wrapper").href : "/");
                }
            },

            navigateCart: function () {
                navState.setNavState('cart');
            },

            getActiveButton: function () {
                const path = window.location.href;
                const elem = document.querySelector("html > body");
                this.buttonStates.home = false;
                this.buttonStates.eten = false;
                this.buttonStates.checkout = false;

                console.log(path);

                if (hasClass(elem, 'doc-type-ordering')) {
                    if (path.indexOf('?categoryid=') > -1) {
                        this.buttonStates.eten = true;
                    }
                    else {
                        this.buttonStates.home = true;
                    }
                }
                else if (hasClass(elem, 'doc-type-checkout')) {
                    this.buttonStates.checkout = true;
                }

                function hasClass(elem, name) {
                    return (elem.className && elem.className.indexOf(name) > -1);
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// Vue/Src/Components/mobile-navigation-bar.vue